import React from 'react'

function Footer() {
  return (
    <div className="footer">
    <footer className="bg-neutral-900">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
            <div className="py-2 text-[var(--text-secondary)]">
            Copyright &copy; Firat YASAR
            </div>
        </div>
    </footer>
    </div>
  )
}

export default Footer
